var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"small":"","color":"red","icon":"","flat":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fal fa-trash")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }